module.exports = __webpack_public_path__ + "static/media/BellHover.7cf5d79a.svg";